import React, { useContext, useEffect, useState, useRef, useCallback } from 'react';
import { RadioGroup, Input, TextArea } from '@progress/kendo-react-inputs';
import { Label } from '@progress/kendo-react-labels';
import Uploader, {uploaderTypes} from '../../Uploader';
import ListEditor from '../../ListEditor';
import { LocalizationContext } from '../../../contexts';
import './index.scss';
import '../forms.scss';

export default function SEO({data, settingsData = {}, onUpdate, validator, ...rest}) {
    const emptyItem = { 
      description: "",
      image: "",
      keyWords: "",
      metaTips: "",
      title: "",
    };
    const [compData, setCompData] = useState({});
    const [localization] = useContext(LocalizationContext);
    const {labels} = localization;

    validator.current = () => {
      return true;
    };

    useEffect(() => {
      let defaultData = {...emptyItem};
      const startCompData = { ...defaultData, ...JSON.parse(JSON.stringify(data?data:{}))};
      setCompData(startCompData);
    }, [data]);

    const updateData = useCallback((newData) =>{
      let newCompData = {...compData, ...newData};
      setCompData(newCompData);
      onUpdate(newCompData);
    }, [compData]);

    return <div className="pageComponent--SEO">
        <div className="form-message">
          {(settingsData && settingsData.message) || "SEO"}
        </div>
        <div className="form-field">
          <label className="form-field__label">{labels.pagesManagement.SEO.title}</label>
          <Input name={'title'} value={compData.title} onChange={({ value }) => updateData({title: value})}></Input>
        </div>
        <div className="form-field">
          <label className="form-field__label">{labels.pagesManagement.SEO.description}</label>
          <TextArea name={'description'} value={compData.description} onChange={({ value }) => updateData({description: value})}></TextArea>
        </div>
        <div className="form-field">
          <label className="form-field__label">{labels.pagesManagement.SEO.keyWords}</label>
          <TextArea name={'keyWords'} value={compData.keyWords} onChange={({ value }) => updateData({keyWords: value})} placeholder={labels.pagesManagement.SEO.keyWords_placeholder}></TextArea>
        </div>
        <div className="form-field">
          <label className="form-field__label">{labels.pagesManagement.SEO.image}</label>
          <Uploader type={uploaderTypes.seoImage} imageUrl={compData.image} prefix={'seo'} onChange={(file) => { updateData({image: file})}} />
        </div>
    </div>;
};